import { parseIsoDateToDateTimeObject } from '../../../common/utilities/dateTimeUtils';
import { Story } from './newsStoryPopupTypes';
import { DateTime } from 'luxon';

const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000;
export const getLatestStories = (stories: Story[] = [], shouldReturnList = false): Story | Story[] | undefined => {
    if(stories.length) {
        const sortedBreakingNewsStories = stories.sort((storyA, storyB) => {
            const storyADate = storyA?.ModifiedWhen 
                ? storyA?.ModifiedWhen 
                : storyA?.ModifiedDateTimeUtc;
            const storyBDate = storyB?.ModifiedWhen 
                ? storyB?.ModifiedWhen 
                : storyB?.ModifiedDateTimeUtc;
            const timeA = storyADate ? parseIsoDateToDateTimeObject(storyADate) : null;
            const timeB = storyBDate ? parseIsoDateToDateTimeObject(storyBDate) : null;

            if (timeA && timeB) {
                if (timeA > timeB) {
                    return -1;
                } else if (timeA < timeB) {
                    return 1;
                }
            }
            return 0;         
        });

        if (shouldReturnList) {
            return sortedBreakingNewsStories;
        }

        const breakingNewsStory = sortedBreakingNewsStories[0];

        const nowUnixTimeInMilliseconds = DateTime.now().toMillis();

        const dateModified = breakingNewsStory?.ModifiedWhen ?? breakingNewsStory?.ModifiedDateTimeUtc;
        const breakingNewsDateTime = dateModified ? parseIsoDateToDateTimeObject(dateModified) : null;
        const breakingNewsUnixTimeInMilliseconds = breakingNewsDateTime ? breakingNewsDateTime.toMillis() : null;

        // eslint-disable-next-line no-extra-parens
        if (breakingNewsUnixTimeInMilliseconds && ((nowUnixTimeInMilliseconds - breakingNewsUnixTimeInMilliseconds) <= twentyFourHoursInMilliseconds)) {
            return breakingNewsStory;
        }
        
    }
    return;
};